import React from 'react'
import Grid from 'atoms/layout/Grid'
import Divider from 'atoms/display/Divider'
import Container from 'atoms/layout/Container'
import Typography from 'atoms/display/Typography'
import Box from 'atoms/layout/Box'
import PageList from 'data/pages.json'
import ButtonLink from 'atoms/navigation/ButtonLink'
import Hidden from 'atoms/layout/Hidden'

export default function Header () {
  return (
    <Container>
      <Box
        py={8}
      >
        <Grid
          container
          spacing={4}
        >
          <Grid
            container
            item
            alignItems="center"
            xs={12}
            sm={8}
            spacing={4}
          >
            <Grid
              item
              xs={12}
            >
              <Typography
                align="right"
                fontWeight={700}
              >
                広島大学大学院統合生命科学研究科<br/>
                数理生命科学プログラム
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
            >
              <Typography
                variant="h4"
                align="right"
                fontWeight={700}
              >
                自己組織化学研究室
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
            >
              <Typography
                align="right"
                fontWeight={700}
              >
                "Chemistry on Self-Organization" Laboratory
              </Typography>
            </Grid>
          </Grid>
          <Hidden smUp>
            <Grid item xs={12}>
              <Divider
                orientation="horizontal"
                variant="middle"
              />
            </Grid>
          </Hidden>
          <Hidden xsDown>
            <Divider
              orientation="vertical"
              flexItem
            />
          </Hidden>
          <Grid
            container
            item
            alignItems="center"
            xs={12}
            sm={4}
            spacing={1}
          >
            {PageList.filter(v => v.path !== '').map(v => (
              <Grid
                key={`path-${v.path}`}
                item
                xs={12}
              >
                <ButtonLink to={v.path} fullWidth>
                  {v.name}
                </ButtonLink>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Box>
    </Container>
  )
}
